export type BpaSource = {
  id: string;
  name: string;
  rankingEntityId: string;
  rankingEntityName: string;
  status: string | null;
  assignedResearcherId: string | null;
  assignedEditorId: string | null;
};

export type BpaRow = BpaSource;

/**
 * De-duplicates a practice area that maps to several taxonomy parents, and nothing else.
 *
 * It used to sort by ranking entity then name too. It cannot: the server pages the list, so ordering
 * has to happen where the paging happens or a page arrives as the wrong slice of the order. And the two
 * orderings genuinely differ — this sorted under JS `localeCompare` while Postgres sorts under
 * `en_US.utf8`, and on the largest edition the two disagree on 104 of 644 positions. Not punctuation:
 * case. Postgres puts `EU and competition` before `Employment`, `localeCompare` the reverse. Re-sorting
 * a server-ordered page here redistributed it.
 *
 * Callers must request `sort=ranking_entity_asc` and render what comes back.
 */
export function toBpaRows(sources: BpaSource[]): BpaRow[] {
  const byId = new Map<string, BpaRow>();
  for (const source of sources) {
    if (!byId.has(source.id)) {
      byId.set(source.id, source);
    }
  }

  return Array.from(byId.values());
}
